<template>
  <div>
    <label v-if="$validate.DataValid(label)" class="input-label">{{ $t(label) }}</label>
    <div class="qty-setter d-flex align-center">
      <v-btn small icon text :disabled="minusDisabled" color="primary" @click="onMinusClicked">
        <v-icon size="20" class="fi-rr-minus-small"></v-icon>
      </v-btn>

      <div class="qty-input">
        <FormInput
          type="number"
          :fieldValue.sync="controlQty"
          hideDetails
          isIntegerOnly
          @onblur="onBlur"
          :disabled="inputDisabled"
        />
      </div>

      <v-btn small icon text :disabled="addDisabled" color="primary" @click="onAddClicked">
        <v-icon size="20" class="fi-rr-plus-small"></v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'

export default {
  name: 'QtySetter',
  components: {
    FormInput,
  },
  props: {
    qty: {
      type: Number,
      required: true,
      default: 1,
    },
    max: {
      type: Number,
      required: false,
      default: -1, // -1 = no limit
    },
    min: {
      type: Number,
      required: false,
      default: 1,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    maxNum() {
      return this.$validate.DataValid(this.max) && this.$validate.regexNumber(this.max) ? this.max : -1
    },
    minusDisabled() {
      if (parseInt(this.controlQty) <= this.min) {
        return true
      }

      return this.disabled
    },
    addDisabled() {
      if (this.maxNum !== -1 && parseInt(this.controlQty) >= this.maxNum) {
        return true
      }

      return this.disabled
    },
    inputDisabled() {
      if (this.maxNum === 0) {
        return true
      }

      return this.disabled
    },
    controlQty: {
      get() {
        return this.qty
      },
      set(val) {
        if (this.$validate.DataValid(val)) {
          this.$emit('update:qty', parseInt(val))
          this.$emit('update-value', parseInt(val))
        }
      },
    },
  },
  watch: {
    qty(val) {
      this.controlQty = val
    },
  },
  methods: {
    onMinusClicked() {
      if (parseInt(this.controlQty) > 1) {
        this.controlQty = parseInt(this.controlQty) - 1
      }
    },
    onAddClicked() {
      if (this.maxNum === -1 || parseInt(this.controlQty) < this.maxNum) {
        this.controlQty = parseInt(this.controlQty) + 1
      }
    },
    onBlur() {
      if (!this.$validate.DataValid(this.controlQty) || parseInt(this.controlQty) < this.min) {
        this.controlQty = this.min
      } else if (this.maxNum !== -1 && parseInt(this.controlQty) > this.maxNum) {
        this.controlQty = this.maxNum
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.qty-setter {
  & > .qty-input {
    flex: 1;
    max-width: 50px;

    & .v-input__slot {
      border: none;
      background: transparent;
    }

    & input {
      text-align: center;
    }
  }
}
</style>
